import * as React from "react";
const SvgFiRrClipboardListCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 12h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m1 4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1m4 3V7c0-2.757-2.243-5-5-5h-.171A3.01 3.01 0 0 0 13 0h-2a3.01 3.01 0 0 0-2.829 2H8C5.243 2 3 4.243 3 7v12c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5M9 4a1 1 0 0 0 1-1c0-.552.449-1 1-1h2c.551 0 1 .449 1 1s.448 1 1 1h1c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zM8 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m1.834-3.477 1.862-1.805a.999.999 0 1 0-1.392-1.436l-1.64 1.59-.811-.766a1 1 0 1 0-1.373 1.455l1.008.951c.314.315.733.488 1.178.488s.865-.173 1.168-.477"
    />
  </svg>
);
export default SvgFiRrClipboardListCheck;
